import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M7 15l10 0","key":"svg-2"}]]

const IconRecordMail = createReactComponent('outline', 'record-mail', 'RecordMail', __iconNode);

export default IconRecordMail;